/**
 * Jackpot Replacer Model
 */

define(function(require, exports, module) {
    'use strict';

    var user = require('user');
    var JackpotModel = require('replacers/jackpot/jackpot.model');

    module.exports = JackpotModel.extend({
        subscribe: function() {
            var subscribe = JackpotModel.prototype.subscribe.apply(this, arguments);
            this.stopListening(user, 'change:currencyCode change:country');
            this.listenTo(user, 'change:currencyCode change:country', this.fetchOnStateDone.bind(this, null));
            return subscribe;
        },

        fetchOnStateDone: function() {
            this.state && this.state.done(this.fetch.bind(this, null));
        },

        parse: function(data, options) {
            var parse = JackpotModel.prototype.parse.call(this, data, options);
            var jackpots = parse.jackpots;
            var raw = parse.raw;

            var casinodata = data[0].casinodata || data[1].casinodata;
            var total = this.parseTotalJackpot(casinodata);

            return {
                jackpots: jackpots,
                total: total,
                raw: raw
            };
        },

        parseTotalJackpot: function(data) {
            return data && data.amountList && data.amountList.amount;
        }
    });
});
